import * as Icons from 'lucide-react';
import { LucideProps } from 'lucide-react';
import { memo } from 'react';

interface ProcessIconProps extends LucideProps {
  name?: string;
}

export const ProcessIcon = memo(({ name, ...props }: ProcessIconProps) => {
  if (!name) return null;

  // Capitalize first letter to match component names if needed, 
  // but lucide exports are PascalCase usually. 
  // We assume the stored name matches the export name (e.g. "Home", "User").
  
  const IconComponent = Icons[name as keyof typeof Icons] as React.ElementType;

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in lucide-react`);
    return <Icons.HelpCircle {...props} />;
  }

  return <IconComponent {...props} />;
});

ProcessIcon.displayName = 'ProcessIcon';
